import React from 'react';
import config from '../../../utils/config';

function CustomPoloCompta() {
	return (
		<div id="main-container" className="main-container nav-effect-1">
			<iframe
				style={{ top: '0px' }}
				id="ouilink-iframe"
				src={`${config.reportingV4Url}custom-polo-compta${window.location.search}`}
			/>
		</div>
	);
}
export default CustomPoloCompta;
